export const getVisitTypeIdWithCode = (codeVisitType, visitTypeList) => {
  const visitType = visitTypeList.find(({ code }) => code === codeVisitType);
  return visitType ? visitType.id : null;
};



// WEBPACK FOOTER //
// ./src/utils/getVisitTypeIdWithCode.js